import { Routes } from '@angular/router';
import { authGuard, permissionGuard } from '@abp/ng.core';
import { HARVESTPLAN_CONFIG } from './harvest-plan/harvest-plan.config';
import { INCIDENT_CONFIG } from './incident/incident.config';
import { INCIDENTPERSTAND_CONFIG } from './incident-per-stand/incident-per-stand.config';
import { LOADPLAN_CONFIG } from './load-plan/load-plan.config';
import { OFFICIALPLANNEDPLANTATION_CONFIG } from './official-planned-plantation/official-planned-plantation.config';
import { OFFICIALPLANNEDPLANTATIONHEADER_CONFIG } from './official-planned-plantation-header/official-planned-plantation-header.config';
import { OFFICIALPLANNEDPLANTATIONPLANT_CONFIG } from './official-planned-plantation-plant/official-planned-plantation-plant.config';
import { PIPELINEPLANNEDPLANTATION_CONFIG } from './pipeline-planned-plantation/pipeline-planned-plantation.config';
import { PIPELINEPLANNEDPLANTATIONHEADER_CONFIG } from './pipeline-planned-plantation-header/pipeline-planned-plantation-header.config';
import { PIPELINEPLANNEDPLANTATIONPLANT_CONFIG } from './pipeline-planned-plantation-plant/pipeline-planned-plantation-plant.config';
import { PIPELINEPROPERTY_CONFIG } from './pipeline-property/pipeline-property.config';
import { ROADPLAN_CONFIG } from './road-plan/road-plan.config';
import { TILLAGEPLAN_CONFIG } from './tillage-plan/tillage-plan.config';
import { HarvestPlan } from './harvest-plan/harvest-plan';
import { Incident } from './incident/incident';
import { IncidentPerStand } from './incident-per-stand/incident-per-stand';
import { LoadPlan } from './load-plan/load-plan';
import { OfficialPlannedPlantation } from './official-planned-plantation/official-planned-plantation';
import { OfficialPlannedPlantationHeader } from './official-planned-plantation-header/official-planned-plantation-header';
import { OfficialPlannedPlantationPlant } from './official-planned-plantation-plant/official-planned-plantation-plant';
import { PipelinePlannedPlantation } from './pipeline-planned-plantation/pipeline-planned-plantation';
import { PipelinePlannedPlantationHeader } from './pipeline-planned-plantation-header/pipeline-planned-plantation-header';
import { PipelinePlannedPlantationPlant } from './pipeline-planned-plantation-plant/pipeline-planned-plantation-plant';
import { PipelineProperty } from './pipeline-property/pipeline-property';
import { RoadPlan } from './road-plan/road-plan';
import { TillagePlan } from './tillage-plan/tillage-plan';

export const OPERATIONAL_ROUTES: Routes = [
  {
    path: 'harvest-plan',
    pathMatch: 'full',
    component: HarvestPlan,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HARVESTPLAN_CONFIG.permission,
      showInMenu: HARVESTPLAN_CONFIG.showInMenu,
      menuCategory: HARVESTPLAN_CONFIG.menuCategory,
      menuSubcategory: HARVESTPLAN_CONFIG.menuSubcategory,
      menuTitle: HARVESTPLAN_CONFIG.localizationKey,
    },
  },
  {
    path: 'incident',
    pathMatch: 'full',
    component: Incident,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INCIDENT_CONFIG.permission,
      showInMenu: INCIDENT_CONFIG.showInMenu,
      menuCategory: INCIDENT_CONFIG.menuCategory,
      menuSubcategory: INCIDENT_CONFIG.menuSubcategory,
      menuTitle: INCIDENT_CONFIG.localizationKey,
    },
  },
  {
    path: 'incident-per-stand',
    pathMatch: 'full',
    component: IncidentPerStand,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INCIDENTPERSTAND_CONFIG.permission,
      showInMenu: INCIDENTPERSTAND_CONFIG.showInMenu,
      menuCategory: INCIDENTPERSTAND_CONFIG.menuCategory,
      menuSubcategory: INCIDENTPERSTAND_CONFIG.menuSubcategory,
      menuTitle: INCIDENTPERSTAND_CONFIG.localizationKey,
    },
  },
  {
    path: 'load-plan',
    pathMatch: 'full',
    component: LoadPlan,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LOADPLAN_CONFIG.permission,
      showInMenu: LOADPLAN_CONFIG.showInMenu,
      menuCategory: LOADPLAN_CONFIG.menuCategory,
      menuSubcategory: LOADPLAN_CONFIG.menuSubcategory,
      menuTitle: LOADPLAN_CONFIG.localizationKey,
    },
  },
  {
    path: 'official-planned-plantation',
    pathMatch: 'full',
    component: OfficialPlannedPlantation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OFFICIALPLANNEDPLANTATION_CONFIG.permission,
      showInMenu: OFFICIALPLANNEDPLANTATION_CONFIG.showInMenu,
      menuCategory: OFFICIALPLANNEDPLANTATION_CONFIG.menuCategory,
      menuSubcategory: OFFICIALPLANNEDPLANTATION_CONFIG.menuSubcategory,
      menuTitle: OFFICIALPLANNEDPLANTATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'official-planned-plantation-header',
    pathMatch: 'full',
    component: OfficialPlannedPlantationHeader,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OFFICIALPLANNEDPLANTATIONHEADER_CONFIG.permission,
      showInMenu: OFFICIALPLANNEDPLANTATIONHEADER_CONFIG.showInMenu,
      menuCategory: OFFICIALPLANNEDPLANTATIONHEADER_CONFIG.menuCategory,
      menuSubcategory: OFFICIALPLANNEDPLANTATIONHEADER_CONFIG.menuSubcategory,
      menuTitle: OFFICIALPLANNEDPLANTATIONHEADER_CONFIG.localizationKey,
    },
  },
  {
    path: 'official-planned-plantation-plant',
    pathMatch: 'full',
    component: OfficialPlannedPlantationPlant,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OFFICIALPLANNEDPLANTATIONPLANT_CONFIG.permission,
      showInMenu: OFFICIALPLANNEDPLANTATIONPLANT_CONFIG.showInMenu,
      menuCategory: OFFICIALPLANNEDPLANTATIONPLANT_CONFIG.menuCategory,
      menuSubcategory: OFFICIALPLANNEDPLANTATIONPLANT_CONFIG.menuSubcategory,
      menuTitle: OFFICIALPLANNEDPLANTATIONPLANT_CONFIG.localizationKey,
    },
  },
  {
    path: 'pipeline-planned-plantation',
    pathMatch: 'full',
    component: PipelinePlannedPlantation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PIPELINEPLANNEDPLANTATION_CONFIG.permission,
      showInMenu: PIPELINEPLANNEDPLANTATION_CONFIG.showInMenu,
      menuCategory: PIPELINEPLANNEDPLANTATION_CONFIG.menuCategory,
      menuSubcategory: PIPELINEPLANNEDPLANTATION_CONFIG.menuSubcategory,
      menuTitle: PIPELINEPLANNEDPLANTATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'pipeline-planned-plantation-header',
    pathMatch: 'full',
    component: PipelinePlannedPlantationHeader,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PIPELINEPLANNEDPLANTATIONHEADER_CONFIG.permission,
      showInMenu: PIPELINEPLANNEDPLANTATIONHEADER_CONFIG.showInMenu,
      menuCategory: PIPELINEPLANNEDPLANTATIONHEADER_CONFIG.menuCategory,
      menuSubcategory: PIPELINEPLANNEDPLANTATIONHEADER_CONFIG.menuSubcategory,
      menuTitle: PIPELINEPLANNEDPLANTATIONHEADER_CONFIG.localizationKey,
    },
  },
  {
    path: 'pipeline-planned-plantation-plant',
    pathMatch: 'full',
    component: PipelinePlannedPlantationPlant,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PIPELINEPLANNEDPLANTATIONPLANT_CONFIG.permission,
      showInMenu: PIPELINEPLANNEDPLANTATIONPLANT_CONFIG.showInMenu,
      menuCategory: PIPELINEPLANNEDPLANTATIONPLANT_CONFIG.menuCategory,
      menuSubcategory: PIPELINEPLANNEDPLANTATIONPLANT_CONFIG.menuSubcategory,
      menuTitle: PIPELINEPLANNEDPLANTATIONPLANT_CONFIG.localizationKey,
    },
  },
  {
    path: 'pipeline-property',
    pathMatch: 'full',
    component: PipelineProperty,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PIPELINEPROPERTY_CONFIG.permission,
      showInMenu: PIPELINEPROPERTY_CONFIG.showInMenu,
      menuCategory: PIPELINEPROPERTY_CONFIG.menuCategory,
      menuSubcategory: PIPELINEPROPERTY_CONFIG.menuSubcategory,
      menuTitle: PIPELINEPROPERTY_CONFIG.localizationKey,
    },
  },
  {
    path: 'road-plan',
    pathMatch: 'full',
    component: RoadPlan,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROADPLAN_CONFIG.permission,
      showInMenu: ROADPLAN_CONFIG.showInMenu,
      menuCategory: ROADPLAN_CONFIG.menuCategory,
      menuSubcategory: ROADPLAN_CONFIG.menuSubcategory,
      menuTitle: ROADPLAN_CONFIG.localizationKey,
    },
  },
  {
    path: 'tillage-plan',
    pathMatch: 'full',
    component: TillagePlan,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TILLAGEPLAN_CONFIG.permission,
      showInMenu: TILLAGEPLAN_CONFIG.showInMenu,
      menuCategory: TILLAGEPLAN_CONFIG.menuCategory,
      menuSubcategory: TILLAGEPLAN_CONFIG.menuSubcategory,
      menuTitle: TILLAGEPLAN_CONFIG.localizationKey,
    },
  },
];
